// @flow

import { hpfetch } from '../util';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';
import type { saleType } from '../../types';

export const getSingle = (
  id: number,
): Promise<wrappedApiResponseType<saleType>> => hpfetch(`sales/${id}/`);

export const getMany = (
  limit: number = 100,
  offset: number = 0,
): djangoModelApiResponse<saleType> =>
  hpfetch(`sales/?limit=${limit}&offset=${offset}`);

const updateSaleStatus = (status: string) => (id: number) =>
  hpfetch(`sales/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify({
      status,
    }),
  });

export const toSellerCanceled = (id: number) =>
  updateSaleStatus('seller_canceled')(id);
export const toAwaitingPayment = (id: number) =>
  updateSaleStatus('awaiting_payment')(id);
export const toPaid = (
  id: number,
  seller_waiver_ids: number[],
  seller_agree: boolean,
) =>
  hpfetch(`sales/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify({
      status: 'paid',
      seller_waiver_ids,
      seller_agree,
    }),
  });

export const toPaidRequestChanges = (id: number) =>
  updateSaleStatus('paid')(id);
export const toAwaitingSecondPaymentBuyerApproval = (id: number) =>
  updateSaleStatus('awaiting_second_payment_buyer_approval')(id);

export const updateSellerPricingFields = (id: number, fields: any) =>
  hpfetch(`sales/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify({
      seller_pricing_fields: fields || {},
    }),
  });

export const updateSellerPricingFieldsWithAddons = (
  id: number,
  fields: any,
  addons: any,
) =>
  hpfetch(`sales/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify({
      seller_pricing_fields: fields || {},
      final_addons: addons || [],
    }),
  });

export const toComplete = (id: number) => updateSaleStatus('complete')(id);

export const report = (id: number, comment: string) =>
  hpfetch(`sales/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify({
      reported: true,
      comment,
    }),
  });

export const updateSellerMiscAdjustment = (
  id: number,
  seller_adjustment: number,
  seller_adjustment_reason: string,
) =>
  hpfetch(`sales/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify({
      seller_adjustment,
      seller_adjustment_reason,
    }),
  });

export const updateSellerFinalPricingAdjustment = (
  id: number,
  final_pricing_fields: {},
) =>
  hpfetch(`sales/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify({
      final_pricing_fields,
    }),
  });

export const updateSellerFinalPricingWithAddonsAdjustment = (
  id: number,
  final_pricing_fields: {},
  addons: any,
) =>
  hpfetch(`sales/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify({
      final_pricing_fields,
      final_addons: addons || [],
    }),
  });

export const addAttachment = (id: number, seller_attachment_ids: number[]) =>
  hpfetch(`sales/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify({
      seller_attachment_ids,
    }),
  });

export const showInStorefront = (id: number) =>
  hpfetch(`sales/${id}/show_in_storefront/`, {
    method: 'POST',
  });

export const hideInStorefront = (id: number) =>
  hpfetch(`sales/${id}/hide_in_storefront/`, {
    method: 'POST',
  });
